export type FileCategory = 'images' | 'videos' | 'audio' | 'documents' | 'sheets' | 'presentations' | 'pdf' | 'other'
export type Ownership = 'all' | 'mine' | 'shared'
export type OrganizationMode = 'original' | 'year-month-type' | 'year-type'
export type ExportFormat = 'pdf' | 'office'
export type CopyStage = 'idle' | 'scanning' | 'ready' | 'copying' | 'complete' | 'partial' | 'error'
export type BackupSourceId = 'gmail' | 'photos' | 'drive'
export type BackupProfileId = 'complete' | 'media' | 'work'
export type BackupDatePreset = 'all' | '6m' | '1y' | '2y' | '5y' | 'custom'
export type BackupIntent = 'backup' | 'clean' | 'both'
export type BackupDestinationMode = 'local' | 'cloud' | 'both'

export interface PendingBackupPlan {
  version: 1
  sources: BackupSourceId[]
  intent: BackupIntent
  profile: BackupProfileId
  organization: OrganizationMode
  datePreset: BackupDatePreset
  after?: string
  before?: string
  gmailQuery?: string
  destinationMode: BackupDestinationMode
  cloudSelected: boolean
  savedAt: string
}

export interface DriveItem {
  id: string
  name: string
  mimeType: string
  size?: string
  modifiedTime?: string
  createdTime?: string
  parents?: string[]
  trashed?: boolean
  ownedByMe?: boolean
  sharedWithMeTime?: string
  driveId?: string
  webViewLink?: string
}

export interface CopyRules {
  categories: Record<FileCategory, boolean>
  age: 'all' | '6m' | '1y' | '2y' | '5y' | 'custom'
  after?: string
  before?: string
  minSizeMb?: number
  maxSizeMb?: number
  ownership: Ownership
  includeTrash: boolean
  folderId?: string
  organization: OrganizationMode
  exportFormat: ExportFormat
}

export interface CopyRecipe {
  id: 'all-drive' | 'media-2y' | 'work-docs' | 'custom'
  title: string
  description: string
  eyebrow: string
}

export interface CopyRecord {
  id: string
  sourceName: string
  outputPath: string
  bytes: number
  status: 'copied' | 'skipped' | 'failed'
  copiedAt: string
  error?: string
  cloudStatus?: 'copied' | 'not-requested' | 'failed'
  cloudKey?: string
  cloudError?: string
}

export interface CopyProgressState {
  current: number
  total: number
  bytesCopied: number
  bytesTotal: number
  bytesKnown: boolean
  currentName: string
  errors: string[]
}

export const emptyCategories = (): Record<FileCategory, boolean> => ({
  images: true,
  videos: true,
  audio: true,
  documents: true,
  sheets: true,
  presentations: true,
  pdf: true,
  other: true,
})

export const defaultRules = (): CopyRules => ({
  categories: emptyCategories(),
  age: 'all',
  ownership: 'all',
  includeTrash: false,
  organization: 'original',
  exportFormat: 'office',
})
